import 'script-loader?!../../../js/jquery/chartinator/chartinator.min.js';

(function () {
    'use strict';
    WhistleOut.Charting = {};
    WhistleOut.Charting.getPieChartConfig = function (
        chartTop,
        chartHeight,
        chartFontSize,
        legendPosition,
        legendMaxLines
    ) {
        return {
            createTable: 'basic-table',
            chartType: 'PieChart',
            chartClass: 'chartinator-chart',
            tableClass: 'chartinator-table',
            pieChart: {
                width: null,
                height: 350,
                chartArea: {
                    top: chartTop,
                    width: '100%',
                    height: chartHeight
                },
                fontSize: chartFontSize,
                fontName: 'Arimo',
                titleTextStyle: {
                    fontSize: 'font-5'
                },
                legend: {
                    position: legendPosition,
                    alignment: 'center',
                    maxLines: legendMaxLines
                },

                colors: [
                    '#289cfb',
                    '#FFB443',
                    '#2c9f2c',
                    '#d52728',
                    '#9467bd',
                    '#8c564b',
                    '#e377c1',
                    '#7f7f7f',
                    '#bcbd22',
                    '#16bdce',
                    '#57a9e2',
                    '#ffb574',
                    '#5fd35f',
                    '#e77c7c',
                    '#c6aedc',
                    '#f4cbe7',
                    '#b2b2b2',
                    '#e2e362',
                    '#5fe0ed',
                    '#103e5d'
                ],
                is3D: true,
                tooltip: {
                    trigger: 'focus'
                }
            },
            showTable: 'hide'
        };
    };
    WhistleOut.Charting.getBarChartConfig = function (element) {
        var chart = {
            chartType: 'BarChart',
            tableClass: 'chartinator-table',
            createTable: 'basic-table',
            transpose: false,
            barChart: {
                width: null,
                height: 400,
                hAxis: {
                    gridlines: {
                        color: '#eee'
                    }
                },
                vAxis: {
                    gridlines: {
                        color: '#eee'
                    }
                },
                chartArea: {
                    left: '15%',
                    top: 30,
                    width: '70%',
                    height: '75%'
                },
                fontName: 'Arimo',
                titleTextStyle: {
                    fontSize: 'font-5'
                },
                legend: {
                    position: 'bottom'
                },
                colors: [
                    '#289cfb',
                    '#FFB443',
                    '#2c9f2c',
                    '#d52728',
                    '#9467bd',
                    '#8c564b',
                    '#e377c1',
                    '#7f7f7f',
                    '#bcbd22',
                    '#16bdce',
                    '#57a9e2',
                    '#ffb574',
                    '#5fd35f',
                    '#e77c7c',
                    '#c6aedc',
                    '#f4cbe7',
                    '#b2b2b2',
                    '#e2e362',
                    '#5fe0ed',
                    '#103e5d'
                ],
                animation: {
                    duration: 1000,
                    easing: 'out',
                    startup: true
                },
                isStacked: false,
                tooltip: {
                    trigger: 'focus'
                }
            },
            showTable: 'hide'
        };
        if (element.is('[data-baseline0]')) {
            chart.barChart.hAxis.baseline = 0;
            chart.barChart.vAxis.baseline = 0;
        }
        return chart;
    };
    WhistleOut.Charting.getColumnChartConfig = function (element, isStacked) {
        if (element.is('[data-stacked]')) {
            isStacked = true;
        }
        var chart = {
            tableClass: 'chartinator-table',
            createTable: 'basic-table',
            chartType: 'ColumnChart',
            chartAspectRatio: 1.5,
            columnChart: {
                width: null,
                chartArea: {
                    left: '10%',
                    top: 30,
                    width: '80%',
                    height: '75%'
                },
                hAxis: {
                    gridlines: {
                        color: '#eee'
                    }
                },
                vAxis: {
                    gridlines: {
                        color: '#eee'
                    }
                },
                fontName: 'Arimo',
                titleTextStyle: {
                    fontSize: 'font-5'
                },
                legend: {
                    position: 'bottom'
                },
                colors: [
                    '#289cfb',
                    '#FFB443',
                    '#2c9f2c',
                    '#d52728',
                    '#9467bd',
                    '#8c564b',
                    '#e377c1',
                    '#7f7f7f',
                    '#bcbd22',
                    '#16bdce',
                    '#57a9e2',
                    '#ffb574',
                    '#5fd35f',
                    '#e77c7c',
                    '#c6aedc',
                    '#f4cbe7',
                    '#b2b2b2',
                    '#e2e362',
                    '#5fe0ed',
                    '#103e5d'
                ],
                animation: {
                    duration: 1000,
                    easing: 'out',
                    startup: true
                },
                isStacked: isStacked,
                tooltip: {
                    trigger: 'focus'
                }
            },
            showTable: 'hide'
        };
        if (element.is('[data-baseline0]')) {
            chart.columnChart.hAxis.baseline = 0;
            chart.columnChart.vAxis.baseline = 0;
        }
        return chart;
    };

    // Render a chart element using the appropriate config based on its class.
    // Marks the element as rendered to prevent duplicate draws on repeated
    // collapse toggles.
    WhistleOut.Charting.renderChart = function ($el) {
        if ($el.attr('data-chart-rendered')) {
            return;
        }
        if ($el.hasClass('barChart')) {
            $el.chartinator(WhistleOut.Charting.getBarChartConfig($el));
        } else if ($el.hasClass('columnChart-stacked')) {
            $el.chartinator(WhistleOut.Charting.getColumnChartConfig($el, true));
        } else if ($el.hasClass('columnChart')) {
            $el.chartinator(WhistleOut.Charting.getColumnChartConfig($el, false));
        } else if ($el.hasClass('pieChart')) {
            var viewportWidth = wo$(window).width();
            if (viewportWidth >= 768) {
                $el.chartinator(WhistleOut.Charting.getPieChartConfig(10, '100%', 14, 'right', 1));
            } else {
                $el.chartinator(WhistleOut.Charting.getPieChartConfig(50, '90%', 12, 'top', 4));
            }
        } else {
            return;
        }
        $el.attr('data-chart-rendered', '1');
    };

    // Render every unrendered chart inside the given jQuery scope.
    WhistleOut.Charting.renderChartsIn = function ($scope) {
        $scope.find('.barChart, .columnChart, .columnChart-stacked, .pieChart').each(function () {
            var $chart = wo$(this);
            if ($chart.closest('.collapse:not(.in)').length === 0) {
                WhistleOut.Charting.renderChart($chart);
            }
        });
    };

    // Render any chart that is NOT inside a currently-collapsed panel.
    // Charts inside an already-open accordion (.collapse.in) or outside any
    // .collapse element render immediately. Charts inside a closed .collapse
    // are skipped here and rendered on shown.bs.collapse instead, once the
    // container has real dimensions for Google Charts to measure the legend.
    WhistleOut.Charting.renderInitialCharts = function () {
        var chartSelector = '.barChart, .columnChart, .columnChart-stacked, .pieChart';
        wo$(chartSelector).each(function () {
            var $chart = wo$(this);
            if ($chart.closest('.collapse:not(.in)').length === 0) {
                WhistleOut.Charting.renderChart($chart);
            }
        });
    };

    // Render charts inside a Bootstrap collapse panel once it finishes
    // opening. Namespaced and unbound first so repeated init calls don't
    // stack duplicate handlers.
    WhistleOut.Charting.bindAccordionRendering = function () {
        wo$(document)
            .off('shown.bs.collapse.chartinator')
            .on('shown.bs.collapse.chartinator', '.collapse', function () {
                WhistleOut.Charting.renderChartsIn(wo$(this));
            });
    };

    WhistleOut.Charting.init = function () {
        WhistleOut.Charting.renderInitialCharts();
        WhistleOut.Charting.bindAccordionRendering();
    };
})();

wo$(WhistleOut.Charting.init);
